export interface ICheckPassword {
  password: string;
}
